import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "@/data/blogPosts";
import { parseSpanishDate } from "@/lib/dates";
import { CATEGORY_STYLES, DEFAULT_CATEGORY_STYLE } from "@/lib/blogCategories";

// Los 9 artículos más recientes del blog (se deja 1 afuera a propósito para
// mantener esta sección compacta — el listado completo vive en /rompiendo-el-techo).
const TEASER_POSTS = [...BLOG_POSTS]
  .sort((a, b) => parseSpanishDate(b.date) - parseSpanishDate(a.date))
  .slice(0, 9);

export default function BlogTeaser() {
  return (
    <section data-testid="blog-teaser-section" className="py-[2.8rem] sm:py-[3.2rem] lg:py-[4rem] bg-slate-50">
      <div className="container-eos">
        <div className="reveal flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 lg:mb-10">
          <div>
            <span className="eyebrow">Blog</span>
            <h2 className="mt-3 font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-navy-800 leading-tight">
              Rompiendo el techo, dolores y reflexiones
            </h2>
          </div>
          <Link
            to="/rompiendo-el-techo"
            data-testid="blog-teaser-view-all"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-[#F26522] hover:gap-2.5 transition-all shrink-0"
          >
            Ver todos los artículos <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="reveal grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5">
          {TEASER_POSTS.map((post) => {
            const meta = CATEGORY_STYLES[post.category] || DEFAULT_CATEGORY_STYLE;
            const Icon = meta.icon;
            return (
              <Link
                key={post.slug}
                to={`/${post.slug}`}
                data-testid={`blog-teaser-link-${post.slug}`}
                className="group flex items-start gap-2.5 min-w-0"
              >
                <Icon className="w-3.5 h-3.5 shrink-0 mt-0.5" strokeWidth={2.25} style={{ color: meta.accent }} />
                <span className="text-sm font-semibold text-navy-800 leading-snug line-clamp-2 group-hover:text-[#F26522] transition-colors">
                  {post.title}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
